import React from 'react';

import {
  styled,
  Box,
  Button,
  IconButton
} from '@mui/material';
import {
  activityTemplates,
  BaseWidget,
  ExportAsnModal,
  PermissionWall,
  routeDirectory,
  useTabSearchParams
} from 'modules';
import {
  useNavigate,
  useParams
} from 'react-router';
import {
  modalUtil,
  TabBar
} from 'iron-forge-react-modules';

import * as OrderListTab from './OrderListTab/OrderListTab';
import * as ReturnAuthorizationListTab from './ReturnAuthorizationListTab/ReturnAuthorizationListTab';

import imgBackArrow from 'assets/images/backArrow/backArrow.svg';



const WidgetContainerBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1)
}));



export const TransactionListActivity: React.FC = () => {
  const params = useParams<{ storeId: string; }>();
  const [tabId, setTabId] = useTabSearchParams({
    defaultTabId: 'orders',
    paramName: 'tabId'
  });
  const navigate = useNavigate();

  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers(['exportAsn']);

  function handleClickExportAsn() {
    setModalIsOpen('exportAsn', true);
  }


  function handleClickBack() {
    navigate(routeDirectory.partner.storeDetail.path(params.storeId ?? ''));
  }

  function handleClickStores() {
    navigate(routeDirectory.partner.stores.path(), {
      replace: true
    });
  }



  return params.storeId ? (
    <>
      <activityTemplates.PartnerActivityTemplate.FC
        storeId={params.storeId}
        elLeftContent={(
          <>
            <IconButton onClick={handleClickBack}>
              <img src={imgBackArrow} />
            </IconButton>

            <Button
              variant="contained"
              onClick={handleClickStores}>
              Stores
            </Button>
          </>
        )}
        elRightContent={(
          <PermissionWall.FC
            storeId={params.storeId}
            requiresPermissions={['reporting_downloadAsn']}>
            <Button
              variant="contained"
              onClick={handleClickExportAsn}>
              Export ASN
            </Button>
          </PermissionWall.FC>
        )}>
        <WidgetContainerBox>
          <BaseWidget.FC>
            <TabBar.FC
              tabId={tabId ?? ''}
              onSelectTab={setTabId}
              tabs={[
                {
                  id: 'orders',
                  label: "Orders"
                },
                {
                  id: 'returnAuthorizations',
                  label: "Return Authorizations"
                }
              ]} />

            {tabId === 'orders' && (
              <OrderListTab.FC storeId={params.storeId} />
            )}

            {tabId === 'returnAuthorizations' && (
              <ReturnAuthorizationListTab.FC storeId={params.storeId} />
            )}
          </BaseWidget.FC>
        </WidgetContainerBox>


      </activityTemplates.PartnerActivityTemplate.FC>

      {modalType2IsOpen.exportAsn && params.storeId && (
        <ExportAsnModal.FC
          storeId={params.storeId}
          onClose={() => setModalIsOpen('exportAsn', false)} />
      )}
    </>
  ) : null;

};
